import React from 'react';
import { FiCalendar } from 'react-icons/fi';

import { ReactComponent as Stethoscope } from '@/assets/icons/stethoscope.svg';
import { ReactComponent as Scissors } from '@/assets/icons/scissors.svg';
import { ReactComponent as Medicine } from '@/assets/icons/medicine.svg';
import { ReactComponent as Referral } from '@/assets/icons/referral.svg';
import { ReactComponent as Document } from '@/assets/icons/document.svg';
import { ReactComponent as Drop } from '@/assets/icons/drop.svg';

import { ArtifactType } from '@/features/artifacts/models/ArtifactForm';

import { TipoLabel } from './styles';

const IconMapping: Partial<Record<ArtifactType, React.ReactElement>> = {
  'solicitacao-exame': <Stethoscope />,
  procedimento: <Scissors />,
  'prescricao-medica': <Medicine />,
  encaminhamento: <Referral />,
  'orientacoes-medicas': <Document />,
  manipulado: <Drop />,
  agendamento: <FiCalendar size={20} />,
};

const DisplayMapping: Partial<Record<ArtifactType, string>> = {
  'solicitacao-exame': 'Exames',
  procedimento: 'Procedimentos',
  'prescricao-medica': 'Medicamentos',
  encaminhamento: 'Encaminhamentos',
  'orientacoes-medicas': 'Orientações',
  manipulado: 'Manipulados',
  agendamento: 'Agendamento',
};

interface Props {
  tipo: ArtifactType;
  label?: string;
}

const TipoArtefatoLabel: React.FC<Props> = ({ tipo, label }) => {
  const displayLabel = label ?? DisplayMapping[tipo];

  return (
    <>
      {IconMapping[tipo]}
      <TipoLabel>{displayLabel}</TipoLabel>
    </>
  );
};

export default TipoArtefatoLabel;
